import Onboarding from "@/components/Onboarding/Index";

export default function OnboardingRoute() {
  return <Onboarding />;
}
